<template>
	<canvas class="featured-element-animation" :id="this.canvasId"></canvas>
</template>

<script>
import axios from "axios";
import * as rive from "@rive-app/canvas";

export default {
	components: {},
	props: {
		id: String,
	},
	data() {
		return {
			riveUrl: "",
			canvasId: "",
		};
	},
	created() {
		axios.get(`/umbraco/api/FeaturedAnimationApi/GetById/${this.id}`).then((response) => {
			this.riveUrl = response.data.mediaId;
		});
		this.canvasId = `featured-animation-canvas-${this.id}`;

    
	},
	mounted: function () {
		window.addEventListener("load", () => {
			const canvas = document.getElementById(this.canvasId);
      const container = document.querySelectorAll(".featured-block-container", `${this.id}`)
    
      const featuredAnimation = new rive.Rive({
				src: this.riveUrl,
				canvas: canvas,
        onLoad:() => {
          featuredAnimation.resizeDrawingSurfaceToCanvas();
        },
        onPlay: (event) => {
          const names = event.data;
          if(names){
            if(names === "Entry"){
              featuredAnimation.play("Entry");
            }
            if(names === "Exit"){
              featuredAnimation.play("Exit")
            }
          }
        }
			});

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // console.log(entry)
          if(entry.boundingClientRect.top > 0){
            featuredAnimation.play("Entry");
          }
        })
      })

      container.forEach((con) => {
        observer.observe(con);
      })
		});
	},
};
</script>
